import React, {Component} from 'react';
class InfoCtrl extends Component {
    render(){
        return(<div>
                <embed src={this.props.fileUrl}  type="application/pdf" 
                width="100%" height="400px" />
        </div>)
    }
}
export default InfoCtrl


// WEBPACK FOOTER //
// ./src/components/Parent/SchoolLunchBreakfastProgram/info.jsx